import { DEFAULT_PAGE_LIMIT } from 'utils/constants';
import httpClient from '../../httpClient';

export const getCentsCustomers = (
  pageNumber = 0,
  searchInput,
  limit = DEFAULT_PAGE_LIMIT,
  sortBy,
  sortOrder,
) => {
  return httpClient({
    method: 'GET',
    url: '/super-admin/customers/',
    params: {
      limit,
      pageNumber: pageNumber + 1,
      searchTerm: searchInput,
      sortBy,
      sortOrder,
    },
  });
};

export const getIndividualCustomer = (id) => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/customers/${id}`,
  });
};

export const deleteIndividualCustomer = (id) => {
  return httpClient({
    method: 'DELETE',
    url: `/super-admin/customers/${id}`,
  });
};

export const updateIndividualValueForCustomer = (id, data) => {
  return httpClient({
    method: 'PUT',
    url: `/super-admin/customers/${id}/update`,
    data,
  });
};

export const uploadCustomerList = (data) => {
  return httpClient({
    method: 'POST',
    url: `/super-admin/customers/upload`,
    data,
  });
};

export const uploadBusinessCustomerDeleteOrRestoreList = (data) => {
  return httpClient({
    method: 'POST',
    url: `/super-admin/customers/business-customers/upload/delete-restore`,
    data,
  });
};

export const uploadFile = (formData) => {
  return httpClient({
    method: 'POST',
    url: '/upload',
    data: formData,
    baseURL: import.meta.env.VITE_CSVDATAEDITOR_BASE_URL,
  });
};

export const addToCreditTable = (id, data) => {
  return httpClient({
    method: 'PUT',
    url: `/super-admin/customers/${id}/update/credit`,
    data,
  });
};

export const getBusinessesByCustomer = (customerId) => {
  return httpClient({
    method: 'GET',
    url: '/super-admin/businesses/by-customer/simple',
    params: { customerId },
  });
};

export const getCreditReasons = () => {
  return httpClient({
    method: 'GET',
    url: '/super-admin/customers/reasons',
  });
};
